import BasePage from "../modules/basePage";
import "../../css/modules/mentorPage/main.scss";
import "../modules/mentor/mentor";
import "alpinejs";

class MentorPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        this.customSelect();
        this.menuClickAway();
        $(function() {
            $('[data-toggle="tooltip"]').tooltip();
        });
    }

    onReady() {
        super.onReady();
    }

    //custom select logic
    customSelect() {
        let selectItems = document.querySelectorAll(".mentorWrap .inner-dropdown-menu .dropdown-item");

        selectItems.forEach(item => {
            item.addEventListener("click", () => {
                let dropdownMenu = item.parentElement;
                dropdownMenu.classList.add("hidden");
                dropdownMenu.classList.remove("open");

                let itemText = item.innerText;
                let dropdownToggle = dropdownMenu.previousElementSibling;
                let dropdownToggleSpan = dropdownToggle.querySelector("span");
                dropdownToggle.classList.add("selected");
                dropdownToggleSpan.innerText = itemText;
                this.removeError(dropdownMenu);
            });
        });
    }
    menuClickAway() {
        window.addEventListener("click", e => {
            let inner = document.querySelector(".mentorWrap .dropdown .inner-dropdown-menu");
            let toggle = document.querySelector(".mentorWrap .dropdown .dropdown-toggle");
            if (inner && inner.length) {
                for (let i = 0; i < inner.length; i++) {
                    if (!e.target.closest(".inner-dropdown-menu") && inner[i].classList.contains("open") && e.target !== toggle[i]) {
                        inner[i].classList.add("hidden");
                        inner[i].classList.remove("open");
                    }
                }
            }
        });
    }
    removeError(input) {
        const formField = input.parentElement;
        formField.classList.remove("error");
        formField.classList.add("success");
        const error = formField.querySelector("small");
        error.textContent = "";
    }
}

new MentorPage();
